import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Fragment } from 'react'

import colors from 'components/utils/colors'

const StyledMark = styled.mark`
  background-color: ${colors.highlight};
`

const escapeRegExp = (str) => {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

const MarkedText = ({ text, markedPart }) => {
  if (!markedPart || text === null || text === undefined) {
    return text
  }
  const newText = (typeof text === 'number') ? text.toString() : text
  const escapedMarkedPart = escapeRegExp(markedPart)
  const regex = new RegExp('(' + escapedMarkedPart + ')', 'i')
  const parts = newText.split(regex).filter(String)

  return (
    <>
      {parts.map((part, i) => {
        return regex.test(part)
          ? <StyledMark key={i}>{part}</StyledMark>
          : <Fragment key={i}>{part}</Fragment>
      })}
    </>
  )
}

MarkedText.propTypes = {
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  markedPart: PropTypes.string,
}

export default MarkedText
